import emailjs from "@emailjs/browser";

export const sendEmail = async (values) => {
	await emailjs
		.send("service_uds580z", "template_10rqrsf", values, {
			publicKey: "user_NC3PwN9O4z4TSXq14bfih",
		})
		.then(
			() => {
				console.log("SUCCESS!");
			},
			(error) => {
				console.log("FAILED...", error);
			}
		);
};
